import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const emergentGoogle = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default function Register() {
  const [form, setForm] = useState({ full_name: "", email: "", mobile: "", password: "", city: "", role: "talent" });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const nav = useNavigate();
  const set = (k, v) => setForm({ ...form, [k]: v });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await register(form);
    setLoading(false);
    if (r.ok) {
      toast.success("Account created. Choose your membership to continue.");
      nav(form.role === "casting" ? "/dashboard/casting" : "/pricing");
    } else toast.error(r.error);
  };

  return (
    <div className="min-h-screen bg-[#0A0A0B]">
      <Header />
      <div className="max-w-2xl mx-auto px-4 py-16">
        <div className="sv-overline mb-3 text-center">Start Your SV Talent Profile</div>
        <h1 className="font-serif-hero text-4xl lg:text-5xl text-center">Join a professional platform<br /> built for talent discovery.</h1>
        <p className="mt-4 text-center text-[#8A8478]">Free to create your account. Membership unlocks the professional biodata builder.</p>

        <div className="mt-10 flex gap-3 justify-center">
          {[
            { v: "talent", l: "I'm Talent" },
            { v: "casting", l: "I'm a Casting Professional" },
          ].map((r) => (
            <button key={r.v} type="button" onClick={() => set("role", r.v)} data-testid={`role-${r.v}`}
              className={`px-5 py-2.5 rounded-full text-xs font-mono-label border transition ${form.role === r.v ? "bg-[#F4EFE4] text-[#0A0A0B] border-[#F4EFE4]" : "bg-[#1A1A1F] text-[#F4EFE4] border-[#5A2E2E]"}`}>
              {r.l}
            </button>
          ))}
        </div>

        <form onSubmit={submit} className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4">
          <input data-testid="reg-name" required placeholder="Full Name" value={form.full_name} onChange={(e) => set("full_name", e.target.value)} className="col-span-2 px-5 py-4 bg-[#1A1A1F] border border-[#5A2E2E] rounded-xl outline-none focus:border-[#C5A059]" />
          <input data-testid="reg-email" required type="email" placeholder="Email" value={form.email} onChange={(e) => set("email", e.target.value)} className="px-5 py-4 bg-[#1A1A1F] border border-[#5A2E2E] rounded-xl outline-none focus:border-[#C5A059]" />
          <input data-testid="reg-mobile" placeholder="Mobile Number" value={form.mobile} onChange={(e) => set("mobile", e.target.value)} className="px-5 py-4 bg-[#1A1A1F] border border-[#5A2E2E] rounded-xl outline-none focus:border-[#C5A059]" />
          <input data-testid="reg-password" required type="password" placeholder="Password (min 6)" minLength={6} value={form.password} onChange={(e) => set("password", e.target.value)} className="px-5 py-4 bg-[#1A1A1F] border border-[#5A2E2E] rounded-xl outline-none focus:border-[#C5A059]" />
          <input data-testid="reg-city" placeholder="City" value={form.city} onChange={(e) => set("city", e.target.value)} className="px-5 py-4 bg-[#1A1A1F] border border-[#5A2E2E] rounded-xl outline-none focus:border-[#C5A059]" />
          <button data-testid="reg-submit" disabled={loading} className="sv-btn-primary col-span-1 md:col-span-2 w-full mt-2">
            {loading ? "Creating account…" : "Continue"}
          </button>
        </form>

        <div className="my-6 flex items-center gap-3 text-xs text-[#8A8478]">
          <div className="flex-1 h-px bg-[#5A2E2E]" />OR<div className="flex-1 h-px bg-[#5A2E2E]" />
        </div>
        <button data-testid="reg-google" onClick={emergentGoogle} className="w-full py-4 border border-[#F4EFE4]/20 rounded-full text-sm hover:bg-[#1A1A1F] transition">Continue with Google</button>

        <p className="text-center text-sm text-[#8A8478] mt-8">Already have an account? <Link to="/login" className="text-[#C5A059] font-medium">Sign in</Link></p>
      </div>
      <Footer />
    </div>
  );
}
